import { useEffect } from 'react';

function GoogleTranslate() {
  useEffect(() => {
    // Nettoyer d'abord si déjà présent
    const existingScript = document.querySelector('script[src*="translate.google.com"]');
    if (existingScript) {
      existingScript.remove();
    }

    const addScript = document.createElement('script');
    addScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(addScript);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'fr',
          includedLanguages: 'fr,en,mg',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        'google_translate_element'
      );

      // Attendre un peu que Google Translate se charge puis appliquer les styles
      setTimeout(() => {
        applyCustomStyles();
      }, 100);
    };

    // Fonction pour appliquer des styles personnalisés
    const applyCustomStyles = () => {
      // Masquer la barre d'outils Google Translate qui apparaît parfois
      const googleToolbar = document.querySelector('.goog-te-banner-frame');
      if (googleToolbar) {
        googleToolbar.style.display = 'none';
      }

      // Masquer le message "Propulsé par Google Traduction"
      const poweredBy = document.querySelector('.goog-te-gadget-simple .goog-te-menu-value span:last-child');
      if (poweredBy) {
        poweredBy.style.display = 'none';
      }

      // Ajuster le style du sélecteur
      const translateSelect = document.querySelector('.goog-te-gadget-simple');
      if (translateSelect) {
        translateSelect.style.border = 'none';
        translateSelect.style.backgroundColor = 'transparent';
      }

      // Masquer les éléments de traduction qui peuvent apparaître ailleurs
      const translateElements = document.querySelectorAll('[id^="goog-gt-"], .skiptranslate');
      translateElements.forEach(element => {
        if (!element.closest('#google_translate_element')) {
          element.style.display = 'none';
        }
      });
    };

    // Observer pour détecter les changements DOM de Google Translate
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          applyCustomStyles();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup
    return () => {
      const script = document.querySelector('script[src*="translate.google.com"]');
      if (script) script.remove();
      
      const gtElem = document.getElementById('google_translate_element');
      if (gtElem) gtElem.innerHTML = '';
      
      if (window.googleTranslateElementInit) {
        delete window.googleTranslateElementInit;
      }
      
      observer.disconnect();
    };
  }, []);

  return (
    <div 
      id="google_translate_element" 
      className="inline-block ml-2"
    />
  );
}

export default GoogleTranslate;